import React, { useState } from "react";
import classes from "./contactus.module.scss";
// import MifabHeader from 'components/MifabHeader';
import InputBox from "components/comman/InputBox";
import { useForm } from "react-hook-form";
import CheckboxGroup from "components/comman/CheckboxGroup";
import TextareaBoxControl from "components/comman/TextBoxWithControl";
import FileUploader from "components/fileupload";
import { IoIosArrowForward } from "react-icons/io";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { API } from "API/API";
import { toast } from "react-toastify";
import { ClipLoader } from "react-spinners";

const schema = yup.object({
  firstName: yup.string().required().label("First name"),
  lastName: yup.string().required().label("Last name"),
  companyName: yup.string().label("Company name"),
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required")
    .label("Email"),
  phone: yup
    .string()
    .matches(/^[0-9]+$/, "Only numeric digits are allowed")
    .min(10, "Phone number must be at least 10 digits")
    .max(15, "Phone number can be up to 15 digits")
    .required("Phone number is required")
    .label("Phone"),
  projectLocation: yup.string().label("Project location"),
  typeFacility: yup.string().label("Type of facility"),
  workingOnType: yup.string().label("New install or retrofit"),
  fixture: yup.string().label("Number of fixtures"),
  estimate: yup.string().label("Estimated flow rate"),
  helpWith: yup.array().of(yup.string()),
  message: yup.string().required().label("Message"),
  fileUpload: yup.string().label("File upload"),
  additionalMessage: yup.string().label("Additional message"),
});

const defaultValues = {
  firstName: "",
  lastName: "",
  companyName: "",
  email: "",
  phone: "",
  projectLocation: "",
  typeFacility: "",
  workingOnType: "",
  fixture: "",
  estimate: "",
  helpWith: [],
  message: "",
  fileUpload: "",
  additionalMessage: "",
};

const ContactPage = () => {
  const [fileInfo, setFileInfo] = useState(null);

  const [loader, setLoader] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(schema),
  });

  const onSubmit = async (val) => {
    const formData = new FormData();

    // Add all form fields to FormData
    formData.append("firstName", val?.firstName.trim() || "");
    formData.append("lastName", val?.lastName.trim() || "");
    formData.append("companyName", val?.companyName.trim() || "");
    formData.append("email", val?.email.trim() || "");
    formData.append("phone", val?.phone.trim() || "");
    formData.append("projectLocation", val?.projectLocation.trim() || "");
    formData.append("facilityType", val?.typeFacility.trim() || "");
    formData.append("projectType", val?.workingOnType.trim() || "");
    formData.append("numberOfFixtures", val?.fixture.trim() || "");
    formData.append("estimateFlowRate", val?.estimate.trim() || "");

    if (val?.helpWith && val?.helpWith?.length > 0) {
      formData.append("problem", val?.helpWith?.join(", "));
    }

    formData.append("message", val?.message.trim() || "");
    formData.append("longDescription", val?.additionalMessage.trim() || "");
    if (fileInfo) {
      formData.append("image", fileInfo);
    }

    try {
      setLoader(true);
      const response = await API.contactSupport(formData);
      if (response?.success) {
        toast.success(response?.message);
        reset(defaultValues);
        setFileInfo(null);
      }else{
        toast.error(response?.message)
      }
    } catch (error) {
      toast.error(error?.message);
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="wrapper">
      <div className={classes.wrapper}>
        <div className="container">
          <h4>Talk to an Expert</h4>
          <h2>
            Need help choosing the right unit or planning a complex install?
          </h2>
          <p>
            Our team is here to guide you through product selection, sizing,
            code compliance, and technical documentation. Whether it’s for a
            single kitchen or a multi-site rollout, we’ll make sure you get it
            right from the start.
          </p>
          <h4>Contact Us</h4>
          <div className={classes.wrapper__contactInfo}>
            <p><strong>Toll Free:</strong> <a href="tel:1-800-465-2736">800.465.2736</a></p>
            <p><strong>Tel:</strong> <a href="tel:773-341-3030">773.341.3030</a></p>
            <p><strong>Fax:</strong> <span>773.341.3047</span></p>
            <p><strong>E-mail:</strong> <a href="mailto:sales@mifab.com">sales@mifab.com</a></p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className={classes.wrapper__row}>
              <div className={classes.wrapper__half}>
                <InputBox
                  name="firstName"
                  control={control}
                  label="First name*"
                />
              </div>
              <div className={classes.wrapper__half}>
                <InputBox
                  name="lastName"
                  control={control}
                  label="Last name*"
                />
              </div>
              <div className={classes.wrapper__full}>
                <InputBox
                  name="companyName"
                  control={control}
                  label="Company name"
                />
              </div>
              <div className={classes.wrapper__half}>
                <InputBox name="email" control={control} label="Email*" />
              </div>
              <div className={classes.wrapper__half}>
                <InputBox name="phone" control={control} label="Phone*" />
              </div>
              <div className={classes.wrapper__full}>
                <h3>Project details</h3>
              </div>
              <div className={classes.wrapper__half}>
                <InputBox
                  name="projectLocation"
                  control={control}
                  label="Project Location (City, Province/State)"
                />
              </div>
              <div className={classes.wrapper__half}>
                <InputBox
                  name="typeFacility"
                  control={control}
                  label="Type of Facility"
                />
              </div>
              <div className={classes.wrapper__half}>
                <InputBox
                  name="workingOnType"
                  control={control}
                  label="Are you working on a new install or retrofit?"
                />
              </div>
              <div className={classes.wrapper__half}>
                <InputBox
                  name="fixture"
                  control={control}
                  label="Number of Fixtures (e.g. sinks, dishwashers, etc.)"
                />
              </div>
              <div className={classes.wrapper__full}>
                <InputBox
                  name="estimate"
                  control={control}
                  label="Estimated Flow Rate (if known)"
                />
              </div>
              <div className={classes.wrapper__full}>
                <h3>
                  What do you need help with? (Checkboxes – multiple selection
                  possible)
                </h3>
              </div>
              <div
                className={`${classes.wrapper__full} ${classes["wrapper--checkbox"]}`}
              >
                <CheckboxGroup
                  name="helpWith"
                  control={control}
                  rules={{ required: "Please select at least one hobby" }}
                  options={[
                    { label: "Product selection", value: "product_selection" },
                    { label: "Sizing", value: "sizing" },
                    {
                      label: "Submittals / compliance",
                      value: "submittals_compliance",
                    },
                    {
                      label: "Installation details",
                      value: "installation_details",
                    },
                    { label: "Pricing / quote", value: "pricing_quote" },
                  ]}
                />
              </div>
              <div className={classes.wrapper__full}>
                <TextareaBoxControl
                  name="message"
                  control={control}
                  label="Message*"
                />
              </div>
              <div className={classes.wrapper__full}>
                <h3>Upload plans or spec sheets (optional)</h3>
                <FileUploader
                  name="fileUpload"
                  control={control}
                  fileInfo={fileInfo}
                  setFileInfo={setFileInfo}
                />
              </div>
              <div className={classes.wrapper__full}>
                <TextareaBoxControl
                  name="additionalMessage"
                  control={control}
                  label="Long text field – Tell us more about your project or any questions you have"
                />
              </div>
              <div className={classes.wrapper__full}>
                {loader ? (
                  <ClipLoader />
                ) : (
                  <button className={classes.btn}>
                    Submit{" "}
                    <span>
                      <IoIosArrowForward />
                    </span>
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
